export default "__VITE_ASSET__DbfrF5og__"